import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";

// Multi-tenant SaaS: Configurable namespace from environment variable
// Must match the namespace used by the Auth0 post-login Action that sets custom claims.
const NAMESPACE = import.meta.env.VITE_AUTH0_NAMESPACE || "https://whatsapp.entrustfi.io";

/**
 * 🏢 MULTI-TENANT SAAS: Resolve the current user's tenant from their JWT.
 *
 * The tenant is ALWAYS derived from the authenticated token claim - never hardcoded.
 * Hardcoding a tenant slug causes cross-tenant requests that the orchestrator's
 * validateUrlTenant() middleware correctly rejects with 403.
 *
 * Returns null when unauthenticated or when the claim is missing, so callers can
 * skip the request rather than silently targeting the wrong tenant.
 */
export const useTenantId = (): string | null => {
  const { user, isAuthenticated } = useAuth0();

  return useMemo(() => {
    if (!isAuthenticated || !user) return null;
    return (user[`${NAMESPACE}/tenant_id`] as string) || null;
  }, [user, isAuthenticated]);
};
